import { render } from "./robotsCom.vue?vue&type=template&id=996e88f2"
import script from "./robotsCom.vue?vue&type=script&lang=js"
export * from "./robotsCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__